export const IMAGES = {
  homeBg: '/images/home-bg.jpeg',
  logo: '/images/logo.jpeg',
};

export const SUIT_COLORS = {
  denari: '#C8971B',
  coppe: '#9A1B1B',
  bastoni: '#2E6B34',
  spade: '#274B7A',
};
